<aside class="filter-panel" [class.collapsed]="!open">
  <div class="filter-header">
    <h6><i class="fa fa-sliders"></i> جستجوی پیشرفته</h6>
    <button class="filter-close" (click)="requestClose()" title="بستن">&times;</button>
  </div>

  <div class="filter-body" [formGroup]="filterForm">
    <!-- دسته‌بندی -->
    <div class="filter-group">
      <div class="filter-group-title" [class.open]="groupsOpen.cat" (click)="toggleGroup('cat')">
        <i class="fa fa-tags"></i> دسته‌بندی
        <span class="group-badge" *ngIf="groupCounts.cat > 0">{{groupCounts.cat | faNum}}</span>
        <i class="fa fa-chevron-left chevron"></i>
      </div>
      <div class="filter-group-content" [class.open]="groupsOpen.cat">
        <div class="filter-field">
          <label>نوع کاربری</label>
          <select formControlName="tiMobileUsage">
            <option [value]="-1">— همه —</option>
            <option *ngFor="let item of options.usageTypes" [value]="item.tiMobileUsage">{{item.strComment}}</option>
          </select>
        </div>
        <div class="filter-field">
          <label>گروه</label>
          <select formControlName="tiMobileGroup">
            <option [value]="-1">— همه —</option>
            <option *ngFor="let item of options.vehicleGroups" [value]="item.tiMobileGroup">{{item.strComment}}</option>
          </select>
        </div>
        <div class="filter-field">
          <label>نوع خودرو</label>
          <select formControlName="tiMobileType">
            <option [value]="-1">— همه —</option>
            <option *ngFor="let item of options.vehicleTypes" [value]="item.tiMobileType">{{item.strComment}}</option>
          </select>
        </div>
        <div class="filter-field">
          <label>برند</label>
          <select formControlName="tiGPSType">
            <option [value]="-1">— همه —</option>
            <option *ngFor="let item of options.vehicleBrands" [value]="item.tiGPSType">{{item.strComment}}</option>
          </select>
        </div>
        <div class="filter-field">
          <label>نوع ردیاب</label>
          <ng-select formControlName="iGPS" [items]="options.trackerTypes" bindLabel="strComment" bindValue="iGPS"
            placeholder="— همه —" [searchable]="true" [clearable]="false"
            notFoundText="موردی یافت نشد" appendTo="body">
          </ng-select>
        </div>
        <div class="filter-field">
          <label>حوزه خدمت</label>
          <select formControlName="iMobileDomain">
            <option [value]="-1">— همه —</option>
            <option *ngFor="let item of options.serviceAreas" [value]="item.iMobileDomain">{{item.strComment}}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- مشخصات خودرو -->
    <div class="filter-group">
      <div class="filter-group-title" [class.open]="groupsOpen.spec" (click)="toggleGroup('spec')">
        <i class="fa fa-car"></i> مشخصات خودرو
        <span class="group-badge" *ngIf="groupCounts.spec > 0">{{groupCounts.spec | faNum}}</span>
        <i class="fa fa-chevron-left chevron"></i>
      </div>
      <div class="filter-group-content" [class.open]="groupsOpen.spec">
        <div class="filter-field">
          <label>نوع سوخت</label>
          <select formControlName="tiFuelType">
            <option [value]="-1">— همه —</option>
            <option [value]="0">ندارد</option>
            <option [value]="1">بنزین</option>
            <option [value]="2">نفت گاز</option>
            <option [value]="3">هیبرید</option>
            <option [value]="4">برقی</option>
          </select>
        </div>
        <div class="filter-field">
          <label>نوع پلاک</label>
          <select formControlName="tiPlateType">
            <option [value]="-1">— همه —</option>
            <option *ngFor="let item of options.plateTypes" [value]="item.tiPlateType">{{item.strComment}}</option>
          </select>
        </div>
        <div class="filter-field">
          <label>تعداد سرنشین</label>
          <input inputmode="numeric" appNumericOnly formControlName="tiPassenger" placeholder="مثلاً ۴">
        </div>
        <div class="filter-field">
          <label>تیپ</label>
          <input formControlName="strVehicleType" placeholder="مثلاً پراید ۱۳۱">
        </div>
        <div class="filter-field">
          <label>بازه کیلومتر</label>
          <div class="range-row">
            <input formControlName="iSKm" placeholder="از">
            <span>تا</span>
            <input formControlName="iEKm" placeholder="تا">
          </div>
        </div>
        <div class="filter-field">
          <label>بازه سال ساخت</label>
          <div class="range-row">
            <input maxlength="4" inputmode="numeric" appNumericOnly formControlName="iSYearConstruction" placeholder="از">
            <span>تا</span>
            <input maxlength="4" inputmode="numeric" appNumericOnly formControlName="iEYearConstruction" placeholder="تا">
          </div>
        </div>
      </div>
    </div>

    <!-- راننده و دستگاه -->
    <div class="filter-group">
      <div class="filter-group-title" [class.open]="groupsOpen.driver" (click)="toggleGroup('driver')">
        <i class="fa fa-id-card"></i> راننده و دستگاه
        <span class="group-badge" *ngIf="groupCounts.driver > 0">{{groupCounts.driver | faNum}}</span>
        <i class="fa fa-chevron-left chevron"></i>
      </div>
      <div class="filter-group-content" [class.open]="groupsOpen.driver">
        <div class="filter-field">
          <label>نام راننده</label>
          <input formControlName="strFullName" placeholder="نام یا نام خانوادگی">
        </div>
        <div class="filter-field">
          <label>موبایل راننده</label>
          <input formControlName="strMobile" placeholder="۰۹۱۲۳۴۵۶۷۸۹">
        </div>
        <div class="filter-field">
          <label>سیم‌کارت ردیاب</label>
          <input formControlName="strCellNo" placeholder="شماره سیم‌کارت">
        </div>
        <div class="filter-field">
          <label>IMEI</label>
          <input formControlName="strUnitID" placeholder="شماره IMEI">
        </div>
        <div class="filter-field">
          <label>پلاک</label>
          <input formControlName="strVehicleNo" placeholder="شماره پلاک">
        </div>
        <div class="filter-field">
          <label>شماره پرسنلی</label>
          <input formControlName="strPersonnelID" placeholder="شناسه پرسنلی">
        </div>
      </div>
    </div>

    <!-- ساعت فعالیت -->
    <div class="filter-group">
      <div class="filter-group-title" [class.open]="groupsOpen.time" (click)="toggleGroup('time')">
        <i class="fa fa-clock-o"></i> ساعت فعالیت
        <span class="group-badge" *ngIf="groupCounts.time > 0">{{groupCounts.time | faNum}}</span>
        <i class="fa fa-chevron-left chevron"></i>
      </div>
      <div class="filter-group-content" [class.open]="groupsOpen.time">
        <div class="filter-field">
          <label>بازه ساعت فعالیت</label>
          <div class="range-row range-stack">
            <div class="clockpicker"><input autocomplete="off" id="strSTime" formControlName="strSTime" placeholder="از"></div>
            <span>تا</span>
            <div class="clockpicker"><input autocomplete="off" id="strETime" formControlName="strETime" placeholder="تا"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="filter-actions">
    <button class="btn-filter-apply" (click)="submitApply()"><i class="fa fa-search"></i> اعمال فیلتر</button>
    <button class="btn-filter-reset" (click)="submitReset()"><i class="fa fa-undo"></i> پاک‌سازی</button>
  </div>
</aside>
<div class="filter-overlay" *ngIf="open" (click)="requestClose()"></div>
